import { Icone } from './Icone'
export default Icone;

export { getIconeSkeleton } from './icone-skeleton';
export { Icone, IconeProps } from './Icone';
